import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Design tokens + the ported panel stylesheet, owned by packages/theme and
// packages/ui. @alpha/ui/styles.css bundles the tokens, but the theme globals
// also carry the body, scrollbar and reset rules the panel depends on.
import '@alpha/theme/global.css';
import '@alpha/ui/styles.css';

import { App } from './App';
// Side-effect import: configures the shared api-client (Sanctum cookie mode)
// before any component can issue a request.
import './lib/api';
import { queryClient } from './lib/queryClient';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
